import { createGlobalStyle } from "styled-components";
import { theme } from "./theme";
import { normalize } from "styled-normalize";

export const GlobalStyles = createGlobalStyle`
    *,*::before,*::after{
        margin: 0;
        padding: 0;
        box-sizing: border-box;
    }
    ${normalize}
    :root{
        --toastify-icon-color-success: ${theme.color.green};
        --toastify-color-progress-success: ${theme.color.green};
        --toastify-icon-color-error: ${theme.color.red};
        --toastify-color-progress-error: ${theme.color.red};
        --toastify-text-color-light: ${theme.color.black}
    }
    html{
        font-size: 10px;
        height:100%;
    }
    body{
        overflow-x: hidden;
        overflow-y: scroll;
        font-family: ${theme.font.primary};
        font-weight: 300;
        font-size: 1.2rem;
        line-height: 133%;
        min-height: 100vh;
        background: ${theme.color.background};
    }
    #root{
        height: 100vh;
    }
    h1,.h1{
        font-weight: 900;
        font-family: ${theme.font.primary};
        font-size: 2.5rem;
        line-height: 124%;
    }
    h2,.h2{
        font-weight: 700;
        font-family: ${theme.font.primary};
        font-size: 1.8rem;
        line-height: 122%;
    }
    h3,.h3{
        font-weight: 700;
        font-family: ${theme.font.primary};
        font-size: 1.6rem;
        line-height: 125%;
    }
    h4,.h4{
        font-weight: 900;
        font-family: ${theme.font.primary};
        font-size: 1.4rem;
        line-height: 128%;
    }
    h5,.h5{
        font-weight: 700;
        font-family: ${theme.font.primary};
        font-size: 1.4rem;
        line-height: 128%;
    }
    h6,.h6{
        font-weight: 700;
        font-family: ${theme.font.primary};
        font-size: 1.2rem;
        line-height: 133%;
    }
    label{
        font-size: 0.8rem;
        font-weight: 500;
        font-family: ${theme.font.secondary};
        color: ${theme.color.gray};
        margin-bottom: 0.1rem;
        text-transform: uppercase;
    }
    input, select, textarea{
        border-radius: 0.3rem;
        border: 0.1rem solid ${theme.color.blue1};
        padding: 0.6rem;
        background: ${theme.color.white};
        margin-bottom: 0.8rem;
        line-height: 133%;
        outline: none;
        font-family: ${theme.font.secondary};
        ::-webkit-input-placeholder {
            color: ${theme.color.gray2};
            font-family: ${theme.font.primary};
            font-weight: 300;
        }
        ::-moz-placeholder {
            color: ${theme.color.gray2};
            font-family: ${theme.font.primary};
            font-weight: 300;
        }
        :-ms-input-placeholder {
            color: ${theme.color.gray2};
            font-family: ${theme.font.primary};
            font-weight: 300;
        }
        :-moz-placeholder {
            color: ${theme.color.gray2};
            font-family: ${theme.font.primary};
            font-weight: 300;
        }
    }
    textarea{
        resize: vertical;
        min-height: 25rem;
    }
    select {
        & > option {
            padding: 0.5rem 0;
        }
    }
    a{
        color: ${theme.color.green};
        text-decoration: none;
    }
    p{
        line-height: 133%;
    }
    strong{
        font-weight: 700;
    }
    .d-flex {
        display: flex;
    }
    .justify-content-end {
        justify-content: end;
    }
    .bigText {
        font-size: 14px
    }
    .m0 {
        margin: 0;
    }
    .react-datepicker {
        transform: scale(1.2);
        margin-top: 1.5rem;
        &__navigation {
            span {
                display: initial !important;
            }
        }
        &__day--selected,
        &__day--keyboard-selected {
        background: ${theme.color.green};
        border-radius: 50% !important;
            &:hover {
                background: ${theme.color.green};
            }
        }
    }
    ol, ul {
        list-style-position: inside;
    }
    a {
        cursor: pointer;
    }
    .ReactModal__Overlay {
        z-index: 1000;
    }
`;
